(() => {
  'use strict';
  if (window.solveFooterPopLoaded) return;
  window.solveFooterPopLoaded = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    root.querySelectorAll('[data-solve-footer-pop]').forEach(footer => {
      if (footer.dataset.popReady) return;
      footer.dataset.popReady = 'true';
      const scene = footer.querySelector('.solve-footer-playground');
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          footer.classList.toggle('is-inview', entries.some(entry => entry.isIntersecting));
        }, { threshold: 0.1 });
        observer.observe(scene);
      } else footer.classList.add('is-inview');
      footer.querySelectorAll('.solve-footer-bubble').forEach(button => {
        button.addEventListener('click', () => {
          if (button.classList.contains('is-popped')) return;
          button.classList.add('is-popped');
          button.dataset.popCount = String(Number(button.dataset.popCount || 0) + 1);
          if (!reduced.matches) {
            const burst = document.createElement('span');
            burst.className = 'solve-footer-burst';
            burst.setAttribute('aria-hidden', 'true');
            for (let i = 0; i < 8; i++) {
              const spark = document.createElement('i');
              const angle = i * Math.PI / 4;
              spark.style.setProperty('--spark-x', Math.round(Math.cos(angle) * 33) + 'px');
              spark.style.setProperty('--spark-y', Math.round(Math.sin(angle) * 33) + 'px');
              burst.appendChild(spark);
            }
            button.appendChild(burst);
            window.setTimeout(() => burst.remove(), 650);
          }
          window.setTimeout(() => button.classList.remove('is-popped'), reduced.matches ? 250 : 850);
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
